<template lang="es">
<div class="profile">
    <Navigation></Navigation>

	<Loader :show="loading" type="inline"></Loader>
	
    <Loader :show="saving"></Loader>


    <div class="container add_top_30 add_bottom_30" v-if="!loading">
        <div class="row">
			
            <div class="col col-lg-3">
                
                <ProfileSidebar></ProfileSidebar>

            </div>

			<div class="col-md-12 col-lg-9" >
                <div class="container box_general">
                    
                    <div class="header_box">
                        <h2><i class="pe-7s-map-marker"></i>Perfil médico</h2>
                    </div>
                    <div class="row">

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Mutualista</label>
                                <multiselect 
                                    v-model="form.mutualists" 
                                    :options="mutualists" 
                                    track-by="id" 
                                    label="name" 
                                    :multiple="true"
                                    :searchable="false"
                                    :placeholder="'Seleccionar opcion'"
                                    :selectLabel="'Seleccionar'"
                                    :selectedLabel="'Seleccionada'"
                                    :deselectLabel="'Quitar'"
                                    >
                                </multiselect>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Seguro Médico</label>
                                <multiselect 
                                    v-model="form.prepaid_medicines" 
                                    :options="prepaid_medicines" 
                                    track-by="id" 
                                    label="name" 
                                    :multiple="true"
                                    :searchable="false"
                                    :placeholder="'Seleccionar opcion'"
                                    :selectLabel="'Seleccionar'"
                                    :selectedLabel="'Seleccionada'"
                                    :deselectLabel="'Quitar'"
                                    >
                                </multiselect>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Emegencia Médica</label>
                                <multiselect 
                                    v-model="form.emergencies" 
                                    :options="emergencies" 
                                    track-by="id" 
                                    label="name" 
                                    :multiple="true"
                                    :searchable="false"
                                    :placeholder="'Seleccionar opcion'"
                                    :selectLabel="'Seleccionar'"
                                    :selectedLabel="'Seleccionada'"
                                    :deselectLabel="'Quitar'"
                                    >
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Afeciones</label>
                                <multiselect 
                                    v-model="form.affections" 
                                    :options="affections" 
                                    track-by="id" 
                                    label="name" 
                                    :multiple="true"
                                    :searchable="true"
                                    :placeholder="'Seleccionar opcion'"
                                    :selectLabel="'Seleccionar'"
                                    :selectedLabel="'Seleccionada'"
                                    :deselectLabel="'Quitar'"
                                    >
                                </multiselect>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row">
                        <div class="col" >
                            <router-link tag="button" class="btn btn-sm pull-left" to="/profile">Volver</router-link>
                            <button class="btn btn-sm pull-right" :class="hasChanges ? 'btn-success' : 'btn-light'"  @click="saveChanges">Guardar cambios</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <Footer></Footer>

</div>
</template>

<script>

import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import Loader from '@/components/Loader';
import ProfileSidebar from '@/components/ProfileSidebar';

export default {
    name: 'Profile',
    metaInfo: {
		title: 'Perfil médico',
	},
    components: {
        Navigation,
        Footer,
        Loader,
        ProfileSidebar,
    },
    data() {
        return {
            form:{},
            hasChanges:false,
            loading:true,
            saving:false,
            mutualists:[],
            emergencies:[],
            prepaid_medicines:[],
            affections:[],
            validationErrors:{},
        }
    },
    computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
    beforeMount(){
        this.loadMedicalEntities();
    },
	methods:{
        loadMedicalEntities(){
            this.$apollo.query({
				query: gql`query ($count: Int!) {
					mutualists(count: $count){
						data{
                            id
                            name
                        }
					}
					emergencies(count: $count){
						data{
                            id
                            name
                        }
					}
					prepaid_medicines(count: $count){
						data{
                            id
                            name
                        }
					}
					affections(count: $count){
						data{
                            id
                            name
                        }
					}
                }`,
                variables: {
					count: 100,
                },
			})
			.then((data) => {
				this.mutualists = data.data.mutualists.data;
				this.emergencies = data.data.emergencies.data;
				this.prepaid_medicines = data.data.prepaid_medicines.data;
				this.affections = data.data.affections.data;
			});
        },
        saveChanges(){
            //this.saving=true;
            this.validationErrors = {};
                
            let mutualists = [];
            if( this.form.mutualists.length>0){
                this.form.mutualists.forEach( (mutualist) => {
                    mutualists.push(mutualist.id);    
                })
            }
            let emergencies = [];
            if( this.form.emergencies.length>0){
                this.form.emergencies.forEach( (emergency) => {
                    emergencies.push(emergency.id);    
                })
            }
            let prepaid_medicines = [];
            if( this.form.prepaid_medicines.length>0){
                this.form.prepaid_medicines.forEach( (prepaid_medicine) => {
                    prepaid_medicines.push(prepaid_medicine.id);    
                })
            }
            let affections = [];
            if( this.form.affections.length>0){
                this.form.affections.forEach( (affection) => {
                    affections.push(affection.id);    
                })
            }
            var dataInput = {		
				mutualists: mutualists,			
				emergencies: emergencies,			
				prepaid_medicines: prepaid_medicines,			
				affections: affections,			
            };
            
            console.log(dataInput);
			
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:UserUpdateMedicProfileInput ){
					userUpdateMedicProfile( data: $data) {
						id
					}
				}`,
				variables: {
					data: dataInput,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados');
                this.saving=false;
                this.hasChanges=false;
            })
            .catch(error => {
                this.$toast.error('Rellene todos los campos!');
                let { graphQLErrors } = error;
                if (graphQLErrors[0].extensions.category === "validation") {
                    this.validationErrors = this.parseErrors(graphQLErrors[0].extensions.validation);
                }else{
                    this.validationErrors['general'] = 'Se ha producido un error';
                }
                this.saving=false;
            })
        },
        parseErrors(errors){
            let parsedErrors = [];
            Object.keys(errors).forEach( (key) => {
                parsedErrors[key] = errors[key][0];
                
            });
            return parsedErrors;
        },
    },
    apollo: {
        me: {
            query: gql`query{
                me {
                    id
                    mutualists{
                        id
                        name
                    }
                    emergencies{
                        id
                        name
                    }
                    prepaid_medicines{
                        id
                        name
                    }
                    affections{
                        id
                        name
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            result (data) {
                this.form = data.data.me;
                // if(this.form.address_locality){
                //     this.form.address_region_id = this.form.address_locality.region.id;	
                // }
                this.loading=false;
            },
        }
    },
    beforeRouteLeave (to, from , next) {
        if(this.hasChanges || this.hasChangesAddress ){
            const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios sin guardar!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next()
        }
    }
    
	
}
</script>

<style scoped>

</style>
